<template>
  <div class="restore-inline-help-modal" v-if="showInlineHelp">
    <div class="modalHeader">
      <span class="title">Question Help</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <h1 v-if="indiceProcessing" class="msg-process">{{ msgProcessing }}</h1>
      <spinner v-show="loading"></spinner>
      <div class="button-box">
        <button class="btn btn-primary btn-lg btn-block" v-if="btnFinish && loading === false" @click="closeModal">Finish</button>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from './Spinner.vue'

export default {
  name: 'restore-inline-help-modal',

  components: {
    Spinner
  },

  data () {
    return {
      showInlineHelp: false,
      loading: false,
      btnFinish: false,
      msgProcessing: '',
      indiceProcessing: false
    }
  },

  mounted () {
    let that = this
    this.$bus.on('showProcessInlineHelp', this.showOnlyProcessSpinner)
    this.$on('showRestoreInlineHelp', function () {
      that.showInlineHelp = true
      that.loading = false
      that.btnFinish = false
      that.msgProcessing = ''
      that.indiceProcessing = false
    })
  },
  methods: {
    showOnlyProcessSpinner (msg) {
      this.loading = msg.state
      this.indiceProcessing = true
      this.msgProcessing = msg.process
      this.btnFinish = !this.loading
    },

    closeModal () {
      this.showInlineHelp = false
      this.loading = false
      this.indiceProcessing = false
    }
  },

  beforeDestroy () {
    // this.$bus.$off('showProcessInlineHelp')
    // this.$off('showRestoreInlineHelp')
  }
}
</script>

<style lang="scss" scoped>
  .restore-inline-help-modal {
    position: fixed;
    top: 30%;
    left: 50%;
    margin-left: -19%;
    width: 50%;
    max-width: 700px;
    min-height: 300px;
    max-height: 90%;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;

    .msg-process {
      text-align: center;
      color: green;
      margin-top: 50px;
      padding: 20px;
    }

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .button-box {
      padding: 5px;
      margin-bottom: 5px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/questionnaires/RestoreInlineHelpModal.vue